<template>
  <div>
    <div class="mt-15 container card_container">
      <modal-lista-sede
        :presaInCarico="presaInCarico"
        @onRifiutaPrimaDisponibilita="onRifiutaPrimaDisponibilita"
        @onSedeSelezionata="onSedeSelezionata"
        @setLoading="setLoading"
        @setListaSedi="setListaSedi"
        @setMountedAfterLista="mountedAfterLista"
        ref="modalListaSede"
        id="modalListaSede"
        @chiudi="chiudi"
      ></modal-lista-sede>
      <modal-cambia-data-disp @getData="getData"></modal-cambia-data-disp>
      <anagrafica :codiceImpegnativa="presaInCarico.nre" :priorita="presaInCarico.classePriorita" :assistito="assistito"></anagrafica>
      <div class="separator border-4 my-3"></div>
       <!-- <div>
            <b-alert show variant="warning">
                <h4 class="alert-heading">Attenzione!</h4>
                <p>
                    {{infoAltreProposte}}
                </p>
            </b-alert>
        </div> -->
      <h3 class="mb-5 titolo"><i class="fas fa-clipboard-list"></i> Proposta (prima disponibilità in ambito distrettuale)</h3>

      <datatable-disponibilita :esamiDisponibili="jsonData.prossimiEsamiDisponibili"></datatable-disponibilita>
      <b-container class="bv-example-row">
        <b-row>
          <b-col sm="12" md="2" lg="2" xl="2">
            <b-button variant="outline-secondary" class="w-100" @click="onAnnulla"><i class="fas fa-trash"></i> Annulla </b-button>
          </b-col>
          <b-col sm="12" md="10" lg="10" xl="10">
            <b-row>
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-button v-if="jsonData.nonErogabili.length === 0" class="w-100 btn-outline" v-b-modal.modalListaSede
                  ><i class="fas fa-calendar-minus"></i>
                  Altre Proposte
                </b-button>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-button v-if="jsonData.nonErogabili.length === 0 && jsonData.prossimiEsamiDisponibili.length>0" class="w-100 btn-outline" @click="onConfermaPrenotazione"><i class="fas fa-clipboard-check"></i> Conferma Proposta </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <modal-disponibilita ref="modalDisponibilita" id="modalDisponibilita" :nonErogabili="jsonData.nonErogabili" @si="si" @no="onAnnulla()"></modal-disponibilita>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
  </div>
</template>
<script>
import anagrafica from "../anagrafica/anagrafica.vue";
import Loading from "vue-loading-overlay";
import DatatableDisponibilita from "../datatable/datatableDisponibilita.vue";
import modalListaSede from "../modal/modalListaSede.vue";
import modalCambiaDataDisp from "../modal/modalCambiaDataDisp.vue";
import modalDisponibilita from "../modal/modalDisponibilita.vue";
import EngiService from "@/services/engiService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  props: {
    assistito: Object,
    presaInCarico: Object,
    esamiDisponibili: Object,
    nonErogabili: Object,
    listaSedi: Array,
    responsePrimaDisponibilita: Object,
  },
  components: {
    anagrafica,
    DatatableDisponibilita,
    modalCambiaDataDisp,
    Loading,
    modalListaSede,
    modalDisponibilita,
  },
  data() {
    return {
        infoAltreProposte:"Per modificare la struttura o le date proposte della prenotazione, seleziona l'opzione \"altre proposte\"." +
            "\n Questo comporterà il rifiuto della prima disponibilità offerta.",
      showModal: false,
      messaggioPrePrenotazione: JSON.parse(sessionStorage.getItem("messaggiUtente")).messaggioPrePrenotazione,
      pathResourceAnnulla: "/api/v2.0/appecupt/aslengi/annullaprenotazionesospesa",
      pathResourceProssimaDisponibilita: "/api/v2.0/appecupt/aslengi/ricercaprimadisponibilita/ricercaorario",
      pathResourceCercaData: "/api/v2.0/appecupt/aslengi/ricercaprimadisponibilita/ricercadata",
      pathResourceConferma: "/api/v2.0/appecupt/aslengi/confermaappuntamento",
      jsonData: {
        prossimiEsamiDisponibili: [],
        nonErogabili: [],
      },
      token: null,
      tokenLogin: null,
      isLoading: false,
    };
  },
  mounted: function () {
    let me = this;
    me.loadData();

      let msg = getVocabolario("infoAltreProposte")
      if(msg)
          this.infoAltreProposte = msg;
  },
  methods: {
    async onConfermaPrenotazione() {
      let me = this;
      me.$bvModal
        .msgBoxConfirm(me.messaggioPrePrenotazione, {
          title: "Conferma Prenotazione",
          footerClass: "p-2",
          centered: true,
          cancelTitle: "Chiudi",
          okTitle: "Conferma",
        })
        .then(async (item) => {
          if (item) {
            try {
              const parametriConferma = {
                index: 0,
              };
              me.isLoading = true;
              const responseConfermaPrenotazione = await EngiService.confermaPrenotazioneNre(parametriConferma);
              me.isLoading = false;
              if (responseConfermaPrenotazione.data.stato === 200) {
                this.$bvModal
                  .msgBoxOk(responseConfermaPrenotazione.data.data, {
                    title: "Esito Prenotazione",
                    size: "md",
                    okVariant: "primary",
                    headerClass: "vv-msg-header-success",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then(() => {
                    me.jsonData.prossimiEsamiDisponibili.splice(0);
                    me.$emit("setStep", 0);
                  })
                  .catch(() => {
                    me.jsonData.prossimiEsamiDisponibili.splice(0);
                    me.$emit("setStep", 0);
                  });
              } else {
                me.isLoading = false;
                this.$bvModal
                  .msgBoxOk(responseConfermaPrenotazione.data.errore, {
                    title: "Errore",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "vv-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then(() => {})
                  .catch((err) => {
                    console.log(err);
                  });
              }
            } catch (e) {
              me.isLoading = false;
              me.$bvModal
                .msgBoxOk(e, {
                  title: "Errore",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {})
                .catch(() => {});
            }
          }
        })
        .catch((err) => {
          me.isLoading = false;
          me.$bvModal
            .msgBoxOk(err, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch(() => {});
        });
    },
    loadData() {
      let me = this;
      me.token = sessionStorage.getItem("tokenWSO2");
      me.tokenLogin = sessionStorage.getItem("loginData");
    },
    mountedAfterLista() {let me = this;
          if(me.responsePrimaDisponibilita.stato === 510){
              me.$bvModal
                  .msgBoxConfirm(me.responsePrimaDisponibilita.errore, {
                      title: "Attenzione",
                      footerClass: "p-2",
                      centered: true,
                      cancelTitle: "Annulla",
                      okTitle: "Conferma",
                  })
                  .then(async (item) => {
                      if(item)
                          this.$bvModal.show('modalListaSede');
                      else
                      {
                          me.jsonData.prossimiEsamiDisponibili.splice(0);
                          me.$emit("setStep", 0);
                      }
                  }).catch(() => {
                  me.jsonData.prossimiEsamiDisponibili.splice(0);
                  me.$emit("setStep", 0);
              });
          }
          else {
              console.log("prima disp",me.responsePrimaDisponibilita)
              if(me.esamiDisponibili.prestazioniDisponibili)
                  me.jsonData.prossimiEsamiDisponibili = me.esamiDisponibili.prestazioniDisponibili;
              if(me.esamiDisponibili?.prestazioniIndisponibili !== undefined) {
                  if (me.esamiDisponibili.prestazioniIndisponibili.length > 0) {
                      me.jsonData.nonErogabili = me.esamiDisponibili.prestazioniIndisponibili;
                      this.$refs["modalDisponibilita"].show();
                  }
              }
          }
      },
    onAnnulla() {
      let me = this;

        let msg = getVocabolario("messaggioAnnullaProceduraPrenotazione")
        if(!msg)
            msg = "Sei sicuro di voler annullare la procedura di Prenotazione dell'impegnativa  "
      me.$bvModal
        .msgBoxConfirm(msg + me.presaInCarico.nre + " ?", {
          title: "Conferma Annullamento",
          footerClass: "p-2",
          centered: true,
          cancelTitle: "Chiudi",
          okTitle: "Conferma",
        })
        .then(async (response) => {
          if (response) {
            me.isLoading = true;
            this.$bvModal.hide('modalDisponibilita');
            this.$bvModal.hide('modalListaSede');
            try {
              await EngiService.annullaPrenotazioneSospesa()
                .then(() => {
                  me.jsonData.prossimiEsamiDisponibili.splice(0);
                  me.isLoading = false;
                  me.$emit("setStep", 0);
                })
                .catch((error) => {
                  me.jsonData.prossimiEsamiDisponibili.splice(0);
                  me.isLoading = false;
                  console.log(error);
                  this.$bvModal
                    .msgBoxOk(error.response, {
                      title: "Errore",
                      size: "sm",
                      okVariant: "outline-danger",
                      headerClass: "vv-msg-header-danger",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                    })
                    .then(() => {})
                    .catch(() => {});
                });
            } catch (e) {
              me.jsonData.prossimiEsamiDisponibili.splice(0);
              me.isLoading = false;
              me.$bvModal
                .msgBoxOk(e, {
                  title: "Errore",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {})
                .catch(() => {});
            }
          }
        });
    },
    getData(data) {
      let me = this;
      me.isLoading = true;
      try {
        const responseRicercaDisponibilita = EngiService.ricercaDisponibilitaNre(data);
        me.isLoading = false;
        if (responseRicercaDisponibilita.data.stato === 200) {
          me.$emit("getProssimaDisponibilita", (me.jsonData.prossimiEsamiDisponibili = responseRicercaDisponibilita.data.data.prestazioniDisponibili));
        } else {
          this.$bvModal
            .msgBoxOk(responseRicercaDisponibilita.data.errore, {
              title: "Errore",
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (e) {
        console.log(e);
      }
    },
    setLoading(value) {
      let me = this;
      me.isLoading = value;
    },
    onRifiutaPrimaDisponibilita(primaDispSede) {
      let me = this;
      me.$emit("setEsamiDisponibili", primaDispSede);
      me.$emit("setStep", 3);
    },
    onSedeSelezionata(sedeSelezionata) {
      let me = this;
      me.$emit("onSedeSelezionata", sedeSelezionata);
    },
    setListaSedi(listaSedi) {
      let me = this;
      me.$emit("setListaSedi", listaSedi);
    },
    si() {
      this.$bvModal.hide('modalDisponibilita');
      if(this.listaSedi.length > 0) {
        this.$bvModal.show('modalListaSede');
      } else {
          let msg = getVocabolario("nessunaDisponibilitaRegionale")
          if(!msg)
              msg = "Non è stata trovata nessuna disponibilità regionale"
        this.$bvModal
            .msgBoxOk(msg, {
              title: "Errore",
              size: "md",
              headerClass: "vv-msg-header-success",
              footerClass: "p-2 border-top-0",
              centered: true,
              hideHeaderClose: true,
              noCloseOnBackdrop: true,
              noCloseOnEsc: true
            })
            .then(async () => {
              try {
                await EngiService.annullaPrenotazioneSospesa()
                    .then(() => {
                      this.isLoading = false;
                      this.$emit("setStep", 0);
                    })
                    .catch((error) => {
                      this.isLoading = false;
                      console.log(error);
                      this.$bvModal
                          .msgBoxOk(error.response, {
                            title: "Errore",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "vv-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                          })
                          .then(() => {
                          })
                          .catch(() => {
                          });
                    });
              } catch (e) {
                this.isLoading = false;
                this.$bvModal
                    .msgBoxOk(e, {
                      title: "Errore",
                      size: "md",
                      okVariant: "outline-danger",
                      headerClass: "vv-msg-header-danger",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                    })
                    .then(() => {
                    })
                    .catch(() => {
                    });
              }
            })
            .catch(() => {
              console.log("Errore");
            });
      }
    },
    chiudi() {
      if(this.jsonData.nonErogabili.length > 0 )
        this.onAnnulla();
      else
        this.$bvModal.hide('modalListaSede');
    }
  },
};
</script>
<style scoped>
.center {
  margin: auto;
  width: 60%;
  padding: 10px;
}
</style>
